<template>
  <div class="personal_body">
    <div class="navbar_style" :class="$store.state.user.isNested && 'navbar_style_nested'">
      <Icon class="navbar_icon" name="arrow-left" @click="$router.back(1)"/>
      <span>{{ l.my_cell_list_info }}</span>
      <div class="icon_box"></div>
    </div>
    <div class="peoBox">
      <div
          @click="navTo(item)"
          class="peoItem"
          :class="item.isFill && 'peoItemNavtive'"
          v-for="(item, index) in pdList"
          :key="index"
      >
        <!-- <img class="peoHeder" :src="item.imgUrl" alt="" /> -->
        <!--        <div class="serial" :class="item.isFill && 'serial_select'">-->
        <!--          {{ index + 1 }}-->
        <!--        </div>-->
        <div class="peoLeftBox">
          <div class="peoTitle" :class="item.isFill && 'peoTitle_select'">
            {{ l[item.title] }}
          </div>
          <img
              v-if="item.isFill"
              class="peoImg"
              src="@/assets/my/yes@2x.png"
              alt=""
          />
          <!--  <img
             v-if="!item.isFill"
             class="peoImg"
             src="@/assets/my/no@2x.png"
             alt=""
           /> -->
        </div>

          <img class="peoRightImg" src="@/assets/my/rightarrow.png" alt="">

      </div>
    </div>
  </div>
</template>

<script>
import {Icon} from "vant";
import {userStatus} from "../../services/home";
import l from "../../locales";

export default {
  name: "personalData",
  components: {
    Icon,
  },
  data() {
    return {
      l: {...l.other, ...l.my},
      pdList: [
        {
          title: "id_nav_title",
          imgUrl: require("@/assets/my/one@2x.png"),
          isFill: false,
          url: "/idcard?from=my",
        },
        {
          title: "basic_nav_title",
          imgUrl: require("@/assets/my/two@2x.png"),
          isFill: false,
          url: "/basicInformation?from=my",
        },
        {
          title: "work_nav_title",
          imgUrl: require("@/assets/my/three@2x.png"),
          isFill: false,
          url: "/work?from=my",
        },
        {
          title: "other_nav_title",
          imgUrl: require("@/assets/my/four@2x.png"),
          isFill: false,
          url: "/other?from=my",
        },
      ],
      pd: undefined,
    };
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      let status = await userStatus();
      if (status.code == 200) {
        this.pd = status.result;
        this.pdList[0].isFill = this.pd.ocr_status == 1;
        this.pdList[1].isFill = this.pd.person_status == 1;
        this.pdList[2].isFill = this.pd.comp_status == 1;
        this.pdList[3].isFill = this.pd.contact_status == 1;

        // this.pdList[0].isFill = true;
        // this.pdList[1].isFill = true;
        // this.pdList[2].isFill = true;
        // this.pdList[3].isFill = true;
      }
    },
    navTo(item) {
      if (item.isFill) {
        this.$router.push(item.url);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.personal_body {
  height: 100%;
  min-height: 100vh;
}

.peoBox {
  box-sizing: border-box;
  padding: 30px 15px;
  padding-top: 0px;

  margin: 0 auto;
  margin-top: 20px;

  width: calc(100% - 30px);
  height: 274px;
  background: #FFFFFF;
  box-shadow: 0px 0px 5px 0px rgba(56, 151, 229, 0.2);
  border-radius: 10px;

  .peoItem {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;

    width: 100%;
    height: 60px;

    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #324353;


    border-bottom: 1px solid #C9D2DC;

    //.peoHeder {
    //  margin-left: 20px;
    //  width: 18px;
    //  height: 18px;
    //}
    //.serial {
    //  position: relative;
    //  width: 20px;
    //  height: 20px;
    //  background: #d8d8d8;
    //
    //  font-size: 14px;
    //  font-family: PingFangSC-Medium, PingFang SC;
    //  font-weight: 500;
    //  color: #9d9fa8;
    //
    //  border-radius: 50%;
    //  display: flex;
    //  justify-content: center;
    //  align-items: center;
    //}
    //.serial_select {
    //  color: #ffffff;
    //  background: linear-gradient(180deg, #B0D7FF 0%, #EF9614 100%);
    //}
.peoLeftBox{
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
    .peoTitle {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      font-size: 16px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      color: #28435B;

      //width: 193px;
      //height: 44px;
      //background: #ffffff;
      //box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
      //border-radius: 13px;
    }

    //.peoTitle_select {
    //  background: rgba(69,161,255,0.79);
    //  color: #FFFFFF;
    //}
    .peoImg {
      width: 14px;
      height: 12px;
      margin-left: 15px;
    }
    .peoRightImg{
      width: 24px;
      height: 24px;
    }

    &:nth-child(n + 2) {
      .serial::after {
        content: "";
        position: absolute;
        top: 0;
        left: 50%;
        transform: translate(-50%, -100%);

        width: 1px;
        height: 44px;
        background: #d8d8d8;
      }

      .serial_select::after {
        content: "";
        position: absolute;
        top: 0;
        left: 50%;
        transform: translate(-50%, -100%);
        background: #F8FBFF;
      }
    }
  }
}
</style>
